import { render, staticRenderFns } from "./LogisticsListEdit.vue?vue&type=template&id=424341fa&scoped=true&"
import script from "./LogisticsListEdit.vue?vue&type=script&lang=js&"
export * from "./LogisticsListEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424341fa",
  null
  
)

export default component.exports